/* MaxPharma - movimento e interacoes: visualizador de PDF, camadas no desktop, objeto em primeiro plano, particulas, revelacao ao rolar e parallax. Sem bibliotecas. Leituras de layout e escritas de estilo ficam em lotes separados (evita reflow forcado). */
(function(){
  var desk = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;

  /* PDF tecnico: no computador abre numa janela sobre a pagina; no celular abre em nova aba */
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest ? e.target.closest('.mx-at__pdf a') : null;
    if(!a || !desk || !desk.matches) return;
    var d = document.getElementById('mx-pdf-dlg');
    if(!d){
      if(typeof HTMLDialogElement === 'undefined') return;
      d = document.createElement('dialog');
      d.id = 'mx-pdf-dlg';
      d.className = 'mx-pdf-dlg';
      d.setAttribute('aria-label', 'Material t\u00e9cnico do fabricante');
      d.innerHTML = '<div class="mx-pdf-dlg__bar"><span class="mx-pdf-dlg__t">Material t\u00e9cnico do fabricante</span>' +
        '<a class="mx-pdf-dlg__new" target="_blank" rel="noopener">Abrir em nova aba</a>' +
        '<button type="button" class="mx-pdf-dlg__x" aria-label="Fechar"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
        '<iframe class="mx-pdf-dlg__f" title="Material t\u00e9cnico do fabricante (PDF)"></iframe>';
      document.body.appendChild(d);
      d.querySelector('.mx-pdf-dlg__x').addEventListener('click', function(){ d.close(); });
      d.addEventListener('click', function(ev){ if(ev.target === d) d.close(); });
      d.addEventListener('close', function(){ d.querySelector('iframe').src = 'about:blank'; document.documentElement.classList.remove('mx-lock'); });
    }
    e.preventDefault();
    d.querySelector('iframe').src = a.href;
    d.querySelector('.mx-pdf-dlg__new').href = a.href;
    d.showModal();
    document.documentElement.classList.add('mx-lock');
  });

  /* 0. Camadas (desktop): o topo fica parado e o conteudo desliza por cima */
  var layers = [].slice.call(document.querySelectorAll('.mx.mx-home .mx-hero,.mx.mx-at .mx-at__hero,.mx.mx-art .mx-art__hero'));
  function setLayers(){
    if(!desk || !desk.matches){
      layers.forEach(function(el){ el.style.top = ''; });
      return;
    }
    var ih = window.innerHeight;
    var hs = layers.map(function(el){ return el.offsetHeight; });
    layers.forEach(function(el, i){ el.style.top = Math.min(0, ih - hs[i]) + 'px'; });
  }
  if(layers.length){
    setLayers();
    window.addEventListener('resize', setLayers, { passive: true });
    window.addEventListener('load', setLayers);
    [].slice.call(document.querySelectorAll('.mx-hero img,.mx-at__hero img,.mx-art__hero img')).forEach(function(i){ if(!i.complete) i.addEventListener('load', setLayers); });
  }

  if(!('IntersectionObserver' in window)) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce) return;

  /* 1. Objeto em primeiro plano: sobe mais rapido que o fundo. O fundo desce devagar,
        limitado a sobra da imagem (escala 1.16 = 8% de margem por lado), para nunca abrir espaco vazio. */
  var fronts = [].slice.call(document.querySelectorAll('.mx-layer'));
  if(fronts.length){
    var lq = false;
    var layerTick = function(){
      if(lq) return; lq = true;
      requestAnimationFrame(function(){
        lq = false;
        var y = window.scrollY || window.pageYOffset || 0;
        var h = window.innerHeight;
        var jobs = [];
        fronts.forEach(function(l){
          var m = l.parentElement;
          var r = m.getBoundingClientRect();
          if(r.bottom < -h || r.top > h) return;
          jobs.push({ l: l, m: m, cap: m.offsetHeight * 0.075 });
        });
        jobs.forEach(function(j){
          var bg = Math.min(y * 0.12, j.cap);
          j.l.style.transform = 'translate3d(0,' + (-y * 0.55).toFixed(1) + 'px,0)';
          j.m.style.setProperty('--bgy', bg.toFixed(1) + 'px');
        });
      });
    };
    window.addEventListener('scroll', layerTick, { passive: true });
    window.addEventListener('resize', layerTick, { passive: true });
    layerTick();
  }

  /* 2. Particulas em tres profundidades sobre a imagem principal dos artigos */
  [].slice.call(document.querySelectorAll('.mx.mx-art .mx-art__hero .mx-media')).forEach(function(m){
    if(!m.querySelector('.mx-pic') || m.querySelector('.mx-fx')) return;
    var fx = document.createElement('div');
    fx.className = 'mx-fx';
    fx.setAttribute('aria-hidden', 'true');
    fx.innerHTML = '<div class="mx-fx__w" data-depth="0.06"><div class="mx-fx__l mx-fx__l--far"></div></div>' +
                   '<div class="mx-fx__w" data-depth="0.16"><div class="mx-fx__l mx-fx__l--mid"></div></div>' +
                   '<div class="mx-fx__w" data-depth="0.3"><div class="mx-fx__l mx-fx__l--near"></div></div>';
    var front = m.querySelector('.mx-layer');
    if(front) m.insertBefore(fx, front); else m.appendChild(fx);
  });
  var fxw = [].slice.call(document.querySelectorAll('.mx-fx__w'));
  if(fxw.length){
    var fxq = false;
    var fxTick = function(){
      if(fxq) return; fxq = true;
      requestAnimationFrame(function(){
        fxq = false;
        var y = window.scrollY || window.pageYOffset || 0;
        fxw.forEach(function(w){
          var d = parseFloat(w.getAttribute('data-depth')) || 0;
          w.style.transform = 'translate3d(0,' + (-y * d).toFixed(1) + 'px,0)';
        });
      });
    };
    window.addEventListener('scroll', fxTick, { passive: true });
    fxTick();
  }

  /* 3. Revelacao: so elementos abaixo da dobra. Primeiro mede tudo, depois escreve. */
  var sel = [
    '.mx .mx-sec-head','.mx .mx-card','.mx .mx-mini','.mx .mx-study','.mx .mx-faq',
    '.mx .mx-diff','.mx .mx-active','.mx .mx-block-title','.mx .mx-box','.mx .mx-spec',
    '.mx .mx-band__inner','.mx .mx-final__inner','.mx .mx-quality__copy','.mx .mx-manifesto__copy',
    '.mx .mx-pillar','.mx .mx-video',
    '.mx .mx-prose > h2','.mx .mx-prose > table','.mx .mx-prose > blockquote'
  ].join(',');
  var vh = window.innerHeight || 800;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
  var cands = [].slice.call(document.querySelectorAll(sel));
  var tops = cands.map(function(el){ return el.getBoundingClientRect().top; });
  cands.forEach(function(el, n){
    if(tops[n] < vh * 0.9) return;
    var p = el.parentElement, i = p ? [].indexOf.call(p.children, el) : 0;
    el.style.transitionDelay = ((i % 3) * 90) + 'ms';
    el.classList.add('mx-rv');
    io.observe(el);
  });

  /* 4. Parallax nas imagens editoriais (a fachada real fica fora, sem zoom) */
  var frames = [].slice.call(document.querySelectorAll(
    '.mx .mx-manifesto__media,.mx .mx-at__media,.mx .mx-card--feature .mx-card__media'
  )).filter(function(f){ return f.querySelector('.mx-pic') && !f.classList.contains('has-layer'); });
  if(!frames.length) return;
  var visible = [];
  var vio = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      var k = visible.indexOf(e.target);
      if(e.isIntersecting && k < 0) visible.push(e.target);
      if(!e.isIntersecting && k > -1) visible.splice(k, 1);
    });
    tick();
  });
  frames.forEach(function(f){ f.classList.add('mx-px'); vio.observe(f); });
  var queued = false;
  function tick(){
    if(queued) return; queued = true;
    requestAnimationFrame(function(){
      queued = false;
      var h = window.innerHeight;
      var rs = visible.map(function(f){ return f.getBoundingClientRect(); });
      visible.forEach(function(f, n){
        var r = rs[n];
        var p = (r.top + r.height / 2 - h / 2) / (h / 2 + r.height / 2);
        if(p > 1) p = 1; if(p < -1) p = -1;
        f.style.setProperty('--py', (-p * r.height * 0.05).toFixed(1) + 'px');
      });
    });
  }
  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', tick, { passive: true });
})();
